import React from "react";
import {
  CRISIS_EMOTION_KEY,
  DEFAULT_EMOTION_WHEN_MISSING,
  getEmotionMeta,
  normalizeReflectionEmotion
} from "../constants/emotions.js";

/**
 * Renders category → specific emotion + meaning for an insight.
 * Crisis / Other: single emotion line only.
 */
export default function EmotionInsightDisplay({
  sentiment,
  emotionCategory,
  emotionLabel = "Emotion",
  categoryLabel = "Category",
  translatedEmotionLabel = null,
  translatedCategory = null,
  translatedMeaning = null,
  className = ""
}) {
  const key = normalizeReflectionEmotion((sentiment || "").trim() || DEFAULT_EMOTION_WHEN_MISSING);
  const meta = getEmotionMeta(key);
  const category = emotionCategory || meta?.category || null;
  const categoryDisplay = translatedCategory || category;
  const emotionName = translatedEmotionLabel || meta?.label || key;
  const meaning = translatedMeaning || meta?.meaning;
  const rootClass = ["emotion-insight-display", className].filter(Boolean).join(" ");

  if (key === CRISIS_EMOTION_KEY || key === DEFAULT_EMOTION_WHEN_MISSING || !meaning || !category) {
    return (
      <dl className={rootClass}>
        <div className="emotion-insight-display__row">
          <dt>{emotionLabel}</dt>
          <dd>{emotionName}</dd>
        </div>
      </dl>
    );
  }

  return (
    <dl className={rootClass}>
      <div className="emotion-insight-display__row">
        <dt>{categoryLabel}</dt>
        <dd>{categoryDisplay}</dd>
      </div>
      <div className="emotion-insight-display__row">
        <dt>{emotionLabel}</dt>
        <dd>
          <span className="emotion-insight-display__name">{emotionName}</span>
          {meaning ? <span className="emotion-insight-display__meaning">{meaning}</span> : null}
        </dd>
      </div>
    </dl>
  );
}
